import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Controller, { inject as controller } from '@ember/controller';
import { task } from 'ember-concurrency';
import FormValidations from 'cio/utils/form-validations';
import RecaptchaService from 'cio/services/recaptcha';
import AnalyticsService from 'cio/services/analytics';
import SignupController from 'cio/pods/signup/controller';
import { ProductApp, productActivationInfo } from 'cio/utils/product-app-info';
import PostRegistrationController from '../controller';

const Validations = {
  useCase(value: string) {
    if (!value?.trim()) {
      return "Can't be blank";
    }

    return true;
  },
};

export default class CompanyController extends Controller {
  validations!: FormValidations;

  @service recaptcha!: RecaptchaService;
  @service analytics!: AnalyticsService;

  declare model: {
    signupType: {
      name: string;
      isJourneys: boolean;
      isDataPipelines: boolean;
    };
  };

  @controller('signup') signupController!: SignupController;
  @controller('authenticated/post-registration') postRegistrationController!: PostRegistrationController;

  queryParams = ['signupType'];

  get isSubmitDisabled() {
    return this.submitTask.isRunning || this.validations.hasErrors;
  }

  constructor() {
    super(...arguments);
    this.set(
      'validations',
      FormValidations.create({ validations: Validations, context: this, modelKey: 'signupController.formValues' }),
    );
  }

  submitTask = task(async (ev: MouseEvent) => {
    ev.preventDefault();

    try {
      await this.validations.validateModel();
    } catch {
      // validation error, don't need to catch
      return;
    }

    await this.trackGoalSubmitted();
    this.signupController.goToNextStep();
  });

  trackGoalSubmitted() {
    return this.analytics.track('signup', 'goal_submitted', {
      useCase: this.signupController.formValues.useCase,
      useCaseDetail: this.signupController.formValues.useCaseDetail,
      signupType: this.signupController.model?.signupType?.name,
    });
  }

  get product() {
    return productActivationInfo[this.signupController.model?.signupType?.name as ProductApp];
  }

  @action
  onValueChange(field: keyof SignupController['formValues'], value: string) {
    this.signupController.setFormValue(field, value);
    this.validations.validateAttribute(field);
  }
}
